export default "__VITE_ASSET__Ciuz9e4G__"